import { template } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { TextStyled } from './styles'

const FaqBlockContent = ({ item, activeIndex, locale }) => {
  const compiled = template(item.content)

  return (
    <TransitionGroup component={null}>
      <CSSTransition key={activeIndex} timeout={{ enter: 400, exit: 700 }}>
        {status => (
          <TextStyled
            {...{ status }}
            className={`with-inverted-links`}
            dangerouslySetInnerHTML={{
              __html: compiled({ locale: `${locale}` }),
            }}
          />
        )}
      </CSSTransition>
    </TransitionGroup>
  )
}

FaqBlockContent.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default FaqBlockContent
